import React, { useState } from "react";
import { ChevronDown, ArrowRight } from "lucide-react";

const FAQS = [
  {
    question: "How accurate is VALIDMAIL?",
    answer:
      "VALIDMAIL achieves 98%+ accuracy through multi-layer validation including syntax checking, domain verification, mailbox existence, and spam trap detection. We continuously update our algorithms and databases to maintain the highest accuracy in the industry.",
  },
  {
    question: "Is my data stored or shared with anyone?",
    answer:
      "No. We never share, sell, or use your data for any purpose other than validation. Email data is encrypted and retained only for the minimum time needed (default 30 days, customizable). You maintain full control and ownership of your data.",
  },
  {
    question: "Do you support real-time validation on forms?",
    answer:
      "Yes! Our real-time API validates emails in under 300ms. You can integrate directly into forms, signup flows, and applications using our JavaScript SDK or REST API. It works seamlessly with all major form builders and frameworks.",
  },
  {
    question: "What happens to invalid and risky emails?",
    answer:
      "You decide! VALIDMAIL classifies emails into categories (Valid, Invalid, Risky, Unknown) with detailed reasons. You can automatically suppress them, flag for review, or apply custom rules based on your risk tolerance and use case.",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <section className="py-16 lg:py-24 bg-white dark:bg-slate-950">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 dark:text-slate-50 mb-4">
            Questions we hear{" "}
            <span className="text-sky-600 dark:text-sky-400">
              most often
            </span>
          </h2>
          <p className="text-lg text-slate-600 dark:text-slate-300">
            Get quick answers to common questions about VALIDMAIL
          </p>
        </div>

        <div className="space-y-4 mb-12">
          {FAQS.map((faq, index) => (
            <div
              key={index}
              className="bg-white dark:bg-slate-900 rounded-2xl border-2 border-slate-200 dark:border-slate-800 overflow-hidden hover:border-sky-300 dark:hover:border-sky-700 transition-all"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-6 text-left"
              >
                <span className="text-lg font-bold text-slate-900 dark:text-slate-50 pr-4">
                  {faq.question}
                </span>
                <ChevronDown
                  className={`h-5 w-5 text-slate-600 dark:text-slate-400 flex-shrink-0 transition-transform ${
                    openIndex === index ? "rotate-180" : ""
                  }`}
                />
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? "max-h-96" : "max-h-0"
                }`}
              >
                <div className="px-6 pb-6 text-slate-600 dark:text-slate-300 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <p className="text-slate-600 dark:text-slate-400 mb-6">
            Still have questions? We're here to help.
          </p>
          <button className="inline-flex items-center gap-2 px-8 py-4 rounded-full text-base font-semibold border-2 border-sky-600 text-sky-600 hover:bg-sky-600 hover:text-white dark:border-sky-500 dark:text-sky-400 dark:hover:bg-sky-500 dark:hover:text-white transition-all duration-300 shadow-md hover:shadow-xl group">
            View full FAQ
            <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </div>
    </section>
  );
}
